import {objectsMerge} from '../../../../../lib/helpers';
import {DndGapState, DndGapStates} from './models';

export const gapFillersId = 'gap-fillers';

export function moveItemToGap(gapStates: DndGapStates,
                              itemId: string,
                              fromGapId: string,
                              toGapId: string | null): DndGapStates {
  if (fromGapId === toGapId)
    return gapStates;

  const patch: { [index: string]: DndGapState } = {};

  if (fromGapId !== gapFillersId) {
    // toSlotId != gapFillersId
    const old = gapStates[fromGapId];
    patch[fromGapId] = {filledWith: null, checked: false, checkCount: old.checkCount};
  }
  if (toGapId !== null && toGapId !== gapFillersId) {
    const old = gapStates[toGapId];
    patch[toGapId] = {filledWith: itemId, checked: false, checkCount: old.checkCount};
  }

  return objectsMerge(gapStates, patch);
}

/******************************************************************************/

export function checkAllItems(gapStates: DndGapStates): DndGapStates {
  let result: { [index: string]: DndGapState } = {};
  for (let [itemId, gapState] of Object.entries(gapStates)) {
    if (gapState.checked || gapState.filledWith === null)
      result[itemId] = gapState;
    else
      result[itemId] = {
        filledWith: gapState.filledWith,
        checked: true,
        checkCount: gapState.checkCount + 1
      };
  }
  return result;
}

/******************************************************************************/

export function usedGapItemIds(gapStates: DndGapStates): readonly string[] {
  let result: string[] = [];
  for (let [, gapState] of Object.entries(gapStates))
    if (gapState.filledWith !== null)
      result.push(gapState.filledWith);
  return result;
}

